import React, { Component } from 'react'
import { Fragment } from 'react'
import { Navigate } from 'react-router-dom';

class Profile extends Component {
    render() { 

          let name;
          let email;
          if(this.props.user){
               name = this.props.user.name;
               email = this.props.user.email;
          }

             if(!localStorage.getItem('token')){
               return <Navigate to="/login" />
          }
          return (
             <Fragment>

<div className="container" style={{ marginTop: "140px", minHeight: "500px" }}>

     <h1 className="mb-4">User Profile Page</h1>

     <ul className="list-group">
          <li className="list-group-item">
               Name : {name}
          </li>

          <li className="list-group-item">
               Email : {email}
          </li>
     </ul>

</div>

</Fragment>
          )
     }
}

export default Profile